//added by delon 2025-04-02

export const Dashboard_MenuPageMap = {
    NEW_MEMBERSHIP_USER: 0,
    NEW_ACTIVE_USER: 1,
    NEW_NON_ACTIVE_USER: 2,
    FIRST_TIME_LOGIN: 3,
    TOTAL_APP_USER: 4,
    TOTAL_APP_TRAFFIC: 5,
    USER_ACTIONS: 6
}